import { DialogRef } from '@angular/cdk/dialog';
import { inject } from '@angular/core';

/**
 * Base class for popup content meant to be opened via `CdkDialogService` (not the raw
 * `Dialog` service directly - `CdkDialogService.open()` has required fixes for render and
 * position timing under zoneless change detection; see that service for details).
 *
 * Not an `@Component` itself (Angular components can't inherit a parent's template/decorator
 * metadata, only class members) - extend this for new CDK-based popups instead of injecting
 * `DialogRef` yourself:
 * ```ts
 * export class MyPopupComponent extends CdkPopupBase<'confirm' | 'cancel'> {
 *   onConfirm(): void {
 *     this.close('confirm');
 *   }
 * }
 * ```
 */
export abstract class CdkPopupBase<TResult = void> {
  protected readonly dialogRef = inject(DialogRef<TResult, CdkPopupBase<TResult>>);

  /** Closes the dialog, optionally returning a result to whoever opened it. */
  protected close(result?: TResult): void {
    this.dialogRef.close(result);
  }
}
